var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-select"},[_c('MultiselectSearch',{attrs:{"open-prefetch":true,"close-on-select":true,"search-url":_vm.searchUrl,"search-options":_vm.searchOptions},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._t("singleLabel",null,{"slot":"singleLabel"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }